(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("aOn2A", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $7617204062632d3c$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");
const $7617204062632d3c$var$ReturnButton = ({ link: link, label: label })=>{
    return /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
        className: "absolute xxl:fixed py-2 lg:py-4 px-1 lg:px-5 top-[54px] lg:top-0 xxl:top-[64px] left-1/2 -translate-x-1/2 max-w-10xl w-full pointer-events-none z-50",
        children: /*#__PURE__*/ (0, $a9eYm.jsxs)("a", {
            href: link,
            className: "group w-fit text-sm md:text-tiny lg:text-base flex gap-2 lg:gap-3 justify-center items-center py-1 md:py-2 lg:py-3 px-2 md:px-5 font-icb rounded-md bg-blue700 text-white pointer-events-auto hover-darken-blue",
            children: [
                /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                    src: "/Images/Icons/Arrows/arrow-right-white.svg",
                    alt: "arrow",
                    width: "20",
                    height: "20",
                    className: "w-5 max-h-[1.2rem] rotate-180 lg:group-hover:-translate-x-1 transition duration-200"
                }),
                label
            ]
        })
    });
};
var $7617204062632d3c$export$2e2bcd8739ae039 = $7617204062632d3c$var$ReturnButton;

});

})();
//# sourceMappingURL=ReturnButton.c8c509dc.js.map
